const CART = {
  MERGE: 'mergeCarts',
  KEEP_PERSISTENT: 'keepPersistentCart',
  KEEP_SESSION: 'keepSessionCart',
};

export default CART;
